const CONFIG = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  HOST:
    import.meta.env.VITE_ENVIRONMENT === 'local'
      ? import.meta.env.VITE_HOST_URL_LOCAL
      : import.meta.env.VITE_HOST_URL,
  JSESSION: import.meta.env.VITE_SESSION_ID,
  USER_EMAIL: import.meta.env.VITE_USER_EMAIL,
  CDN_VIDEO_URL:
    import.meta.env.VITE_CDN_VIDEO_URL || 'https://lets-orange.b-cdn.net/video',
};

export const DEFAULT_LANGUAGE = 'en';
export default CONFIG;
